module.exports = __webpack_public_path__ + "img/part_tab2_box4_bg.f1c04a8a.jpg";